// src/store/useBottomSheetStore.js
import { create } from 'zustand';

const useBottomSheetStore = create((set) => ({
  isOpen: false,
  title: '',
  content: null,
  openSheet: ({ title, content }) => set({ isOpen: true, title, content }),
  closeSheet: () => set({ isOpen: false, content: null }),
}));

export default useBottomSheetStore;
